import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";
import { useScrollytellTranslation } from "./scrollytellContext";

export const DeleteConfirmDialog = ({
  open,
  title,
  containerCount = 0,
  blockCount = 0,
  onConfirm,
  onCancel,
}) => {
  const t = useScrollytellTranslation();

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      aria-labelledby="delete-confirm-dialog-title"
      aria-describedby="delete-confirm-dialog-description"
      role="dialog"
    >
      <DialogTitle id="delete-confirm-dialog-title">
        {t("deleteConfirmDialog.title", "Vil du slette kapittel?")}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="delete-confirm-dialog-description">
          {t(
            "deleteConfirmDialog.description",
            `Er du sikker på at du vil slette kapittelet «${title}»? Dette fjerner ${containerCount} containere og ${blockCount} innholdsblokker. Handlingen kan også angres med Ctrl+Z.`,
            { title, containerCount, blockCount }
          )}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="inherit" autoFocus>
          {t("deleteConfirmDialog.cancel", "Avbryt")}
        </Button>
        <Button onClick={onConfirm} color="error" variant="contained">
          {t("deleteConfirmDialog.confirm", "Slett kapittel")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
